import { ComponentType } from "react"
import { Block, IconProps, Link02, useStyletron } from "@mezo-org/mezo-clay"

import mezoLogo from "#/assets/mezostache-white.svg"

type LinkItemProps = {
  color: string
  Icon: string | ComponentType<IconProps>
}

function LinkItem({ color, Icon }: LinkItemProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        background: color,
        borderRadius: theme.sizing.scale800,
        width: "80px",
        height: "80px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px 8px 36px 0px rgba(0, 0, 0, 0.17)",
      })}
    >
      {typeof Icon === "string" ? (
        <Block
          as="img"
          src={Icon}
          className={css({
            objectFit: "contain",
            width: theme.sizing.scale1400,
            height: theme.sizing.scale1400,
          })}
        />
      ) : (
        <Icon color={theme.colors.white} size={theme.sizing.scale1200} />
      )}
    </Block>
  )
}

export default function OnboardingModalLink({ color, Icon }: LinkItemProps) {
  const [css, theme] = useStyletron()

  return (
    <Block className={css({ display: "flex", alignItems: "center" })}>
      <LinkItem color={theme.colors.accent} Icon={mezoLogo} />
      <Block
        className={css({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          zIndex: 2,
          marginInline: `-${theme.sizing.scale300}`,
          borderRadius: "100%",
          background: theme.colors.primaryB,
          width: theme.sizing.scale1000,
          height: theme.sizing.scale1000,
        })}
      >
        <Link02 color={theme.colors.black} size={20} />
      </Block>
      <LinkItem color={color} Icon={Icon} />
    </Block>
  )
}
